// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarCompromissosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/buscar_compromissos
 *
 * Validates input for fetching compromissos within a date range.
 */
import { registerContract } from './validate'

export interface Agenda_BuscarCompromissosInput {
start: string
end: string
}

registerContract('Agenda_BuscarCompromissosInput', {
  start: { type: 'string',  required: true },
  end:   { type: 'string',  required: true },
})
